import {ThunkAsyncAction} from '../../appThunk';
import {makeGetUserVisualWorkspace} from './visualWorkspace/visualWorkspaceSelectors';
import {updateWorkspaceAsyncAction} from './workspaceActions';

/*
 * Action creators.
 */

/**
 * Updates the user's workspaces, alphabetizing a majority of it.
 *
 * This alphabetizes
 * - private and team tags in the personal teammate workspace,
 * - team inboxes and team custom views in team workspaces, and
 * - teammates in the assigned teammate workspace.
 *
 * This does not alphabetize the inbox section and labels in the personal teammate workspace.
 */
export function alphabetizeWorkspacesAsyncAction(): ThunkAsyncAction {
  const getShouldAlphabetize = () => true;
  return async (dispatch, getState) => {
    const getAlphabetizedVisualWorkspace = makeGetUserVisualWorkspace(
      getShouldAlphabetize,
      'alphabetizeWorkspacesAsyncAction',
    );
    const state = getState();
    const alphabetizedVisualWorkspace = getAlphabetizedVisualWorkspace(state);

    await dispatch(updateWorkspaceAsyncAction(alphabetizedVisualWorkspace));
  };
}
